const PassengerCondition = {
    DOMESTIC: "domestic",
    FOREIGN: "foreign",
    RESIDENT: "resident",
};

export default PassengerCondition;
